/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Box, Typography, Divider, Button, Popover } from "@mui/material";
import CountInfo from "../../components/Composables/TilesCountInfo.js";
import API from "../../Utils/Interceptor/ApiMiddleware.js";
import LoadingSpinner from "../../components/Composables/CircularProgressBar.js";
import DynamicDataGrid from "../../components/Composables/DynamicDataGrid.js";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { useNavigate } from "react-router-dom";
import formatters from "../../components/Composables/DataGridFormatters.js";
import CreateEmployer from "../../components/EmployerComponents/CreateEmployer.js";
import DynamicForm from "../../components/Composables/DynamicForm.js";
// import { useSearchParams } from "react-router-dom";

const EmployerPage = () => {
  const [formState, setFormState] = useState({});
  // const [searchParams, setSearchParams] = useSearchParams();
  const [employerData, setEmployerData] = useState({
    countData: [],
    listData: [],
    paginationModel: {
      pageSize: 25,
      page: 0,
    },
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const [formConfigurations, setFormConfigurations] = useState();
  const [openDialog, setOpenDialog] = useState({
    employerCreate: false,
    filter: false,
  });
  const [loading, setLoading] = useState({
    count: false,
    grid: false,
  });
  // const updatePaginationInURL = (newPaginationModel) => {
  //   setSearchParams({
  //     page: newPaginationModel.page,
  //     pageSize: newPaginationModel.pageSize,
  //   });
  // };
  const handleChange = (key, value, inputValue = null) => {
    setFormState((prev) => ({
      ...prev,
      [key]: value,
      [`${key}Input`]: inputValue !== null ? inputValue : prev[`${key}Input`],
    }));
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleResetFilters = async () => {
    setFormState({});
    setEmployerData((prevState) => ({
      ...prevState,
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    }));
  };

  const fetchEmployerData = async () => {
    setLoading({
      ...loading,
      count: true,
    });
    try {
      const payload = {
        tile_type: "employer_count",
      };
      const response = await API.post("tiles/get-count", payload);
      const apiData = response.data.data;

      setEmployerData((prevState) => ({
        ...prevState,
        countData: apiData,
      }));
    } catch (error) {
      console.error("Error fetching employer data:", error);
    } finally {
      setLoading({
        ...loading,
        count: false,
      });
    }
  };

  const fetchEmployerGridData = async () => {
    const payload = {
      name: formState?.employerName || "",
      email: formState?.employerEmail || "",
      is_active:
        formState?.employerStatus === 0 || formState?.employerStatus === 1
          ? formState?.employerStatus
          : null,
      limit: employerData.paginationModel.pageSize,
      pageNumber: employerData.paginationModel.page + 1,
      is_delete: formState?.employerStatus || null,
    };

    setLoading({
      ...loading,
      grid: true,
    });
    try {
      const response = await API.post("employer/get-employers", payload);
      const apiData = response.data.data;

      setEmployerData((prevState) => ({
        ...prevState,
        listData: apiData,
      }));
      handleClose();
    } catch (error) {
      console.error("Error fetching employer grid data:", error);
    } finally {
      setLoading({
        ...loading,
        grid: false,
      });
    }
  };

  const fetchEmployerFilterData = async () => {
    try {
      const response = await API.get("employer/get-employer-filter-details");
      if (response) {
        const apiData = response.data.data;
        const NameOptions = apiData.map((item) => ({
          value: item.name,
          label: item.name,
        }));

        const EmailOptions = apiData.map((item) => ({
          value: item.email,
          label: item.email,
        }));

        const formConfigurations = [
          {
            label: "Status",
            type: "autocomplete-single",
            name: "employerStatus",
            options: [
              { value: 0, label: "Active" },
              { value: 1, label: "Paused" },
              { value: 2, label: "Deleted" },
            ],
            text: "Status",
          },
          {
            label: "Name of the Employer",
            type: "autocomplete-multiple",
            name: "employerName",
            options: NameOptions,
            text: "Employer Name",
          },
          {
            label: "Email of the Employer",
            type: "autocomplete-multiple",
            name: "employerEmail",
            text: "Employer Email",
            options: EmailOptions,
          },
        ];

        setFormConfigurations(formConfigurations);
      }
    } catch (error) {
      console.error("Error fetching employer filter data:", error);
    }
  };

  const handleRowSelection = (row) => {
    const email = employerData?.listData?.data?.find(
      (item) => item?.id === row?.id
    )?.Email;
    navigate(`/employer-description/${row.id}`, {
      state: {
        id: row.id,
        email: email,
      },
    });
  };

  useEffect(() => {
    fetchEmployerData();
    fetchEmployerFilterData();
  }, []);

  useEffect(() => {
    fetchEmployerGridData();
  }, [employerData.paginationModel]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        boxSizing: "border-box",
        borderRadius: "24px 0 0 0",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "16px",
          marginBottom: "20px",
          flexShrink: 0,
        }}
      >
        <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
          Employer
        </Typography>
        {/* <Divider sx={{ marginTop: "16px" }} /> */}

        {loading.count ? (
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "8px",
              flex: 1,
              textAlign: "center",
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100px",
            }}
          >
            <LoadingSpinner />
          </Box>
        ) : employerData.countData.length > 0 ? (
          <CountInfo sections={employerData.countData} showHeader={false} />
        ) : (
          <CountInfo sections={[]} showHeader={false} />
        )}
      </Box>
      <Box
        sx={{
          borderRadius: "12px",
          padding: "16px",
          backgroundColor: "white",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
            flexShrink: 0,
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
            List of Employers
          </Typography>

          <Box sx={{ display: "flex", gap: "12px" }}>
            <Button
              onClick={() =>
                setOpenDialog({
                  ...openDialog,
                  employerCreate: true,
                })
              }
              sx={{
                display: "flex",
                alignItems: "center",
                borderRadius: "5px",
                backgroundColor: "#2196F3",
                padding: "6px 10px",
                color: "white",
              }}
            >
              <PersonAddIcon sx={{ fontSize: "18px", marginRight: "5px" }} />
              <Typography sx={{ fontSize: "14px" }}>EMPLOYER</Typography>
            </Button>

            <Button
              onClick={(e) => handleOpen(e)}
              sx={{
                display: "flex",
                alignItems: "center",
                borderRadius: "5px",
                backgroundColor: "#2196F3",
                padding: "6px 10px",
                color: "white",
              }}
            >
              <FilterAltOutlinedIcon
                sx={{ fontSize: "18px", marginRight: "5px" }}
              />
              <Typography sx={{ fontSize: "14px" }}>FILTER</Typography>
            </Button>
          </Box>
        </Box>
        <Box sx={{ flex: 1, overflow: "hidden" }}>
          <DynamicDataGrid
            rows={employerData.listData?.data || []}
            showCheckbox={false}
            onRowSelection={handleRowSelection}
            formatters={formatters}
            totalRows={employerData.listData?.totalRows || 0}
            paginationModel={employerData.paginationModel}
            onPaginationModelChange={(newPaginationModel) => {
              setEmployerData((prevState) => ({
                ...prevState,
                paginationModel: newPaginationModel,
              }));
              navigate(`/employer?page=${newPaginationModel.page + 1}`);
            }}
            loading={loading.grid}
          />
        </Box>
      </Box>
      <CreateEmployer
        open={openDialog.employerCreate}
        onClose={() => setOpenDialog({ ...openDialog, employerCreate: false })}
        fetchEmployerGridData={fetchEmployerGridData}
        fetchEmployerData={fetchEmployerData}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ padding: 2, width: 300 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Employer Filters
          </Typography>
          <Divider sx={{ my: 1 }} />
          {formConfigurations ? (
            <DynamicForm
              formData={formConfigurations}
              formState={formState}
              handleChange={handleChange}
            />
          ) : (
            <LoadingSpinner />
          )}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}
          >
            <Button onClick={handleResetFilters}>Reset</Button>
            <Button variant="contained" onClick={fetchEmployerGridData}>
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default EmployerPage;
